import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import { GetNewButton } from "../GetNewButton/GetNewButton";
import { ChangeWithButton } from "../ChangeWithButton/ChangeWithButton";
import { Testbuy } from "@coworker/apprestructured/src/testbuy/services/testbuy.service";
import { TestBuyProductWithCriteria } from "@coworker/types/lib/testbuy";
import { ChangeVariantButton } from "../ChangeVariantButton/ChangeVariantButton";
import { ProductVariant } from "@coworker/apprestructured/src/shared/hooks/item/useItemVariants";
import { useTranslation } from "@coworker/locales";

interface ChangeArticleSheetProps {
  visible: boolean;
  onClose: () => void;
  article: TestBuyProductWithCriteria;
  testbuy: Testbuy;
  area: string;
  onOpenVariant: (variants: ProductVariant[]) => void;
}

export const ChangeArticleSheet = ({
  visible,
  onClose,
  article,
  testbuy,
  area,
  onOpenVariant,
}: ChangeArticleSheetProps) => {
  const { t } = useTranslation();
  return (
    <FixaModal visible={visible} handleCloseBtn={onClose} keepContentMounted>
      <FixaSheets
        ariaLabel={t("changeArticleString")}
        header={<FixaModalHeader closeBtnClick={onClose} />}
        footer={null}
      >
        <FixaModalBody>
          <FixaListView id="change-article-options">
            <GetNewButton
              article={article}
              testbuy={testbuy}
              area={area}
              onClose={onClose}
            />
            <ChangeWithButton
              article={article}
              testbuy={testbuy}
              area={area}
              onClose={onClose}
            />
            <ChangeVariantButton
              article={article}
              testbuy={testbuy}
              area={area}
              onOpenVariant={onOpenVariant}
            />
          </FixaListView>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
};
